import Script from "next/script";
import Head from "next/head";

const Favicon = ({ websiteType }) => {
  const path = `/favicon/${websiteType}/`;

  return (
    <>
      <Head>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${path}apple-touch-icon.png`}
        />
        <link rel="icon" type="image/svg+xml" href={`${path}favicon.svg`} />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={`${path}favicon-32x32.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={`${path}favicon-16x16.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="96x96"
          href={`${path}favicon-96x96.png`}
        />
        <link
          rel="manifest"
          href={`${path}site.webmanifest`}
          fetchpriority="low"
        />
        <link
          rel="mask-icon"
          href={`${path}safari-pinned-tab.svg`}
          color="#000000"
        />
        <link rel="shortcut icon" href={`${path}favicon.ico`} />
        <meta name="apple-mobile-web-app-title" content="Petrotec" />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="theme-color" content="#ffffff" />
      </Head>

      <Script
        id={`manifest-loader-${websiteType}`}
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function() {
              var link = document.createElement('link');
              link.rel = 'manifest';
              link.href = '${path}site.webmanifest';
              
              if ('requestIdleCallback' in window) {
                requestIdleCallback(function() {
                  document.head.appendChild(link);
                });
              } else {
                setTimeout(function() {
                  document.head.appendChild(link);
                }, 1000);
              }
            })();
          `,
        }}
      />
    </>
  );
};
export default Favicon;
